(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tab-build-custom-roll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-tab-roll')) {
    customElements.define('collection-tab-roll', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-tab]');
          if (this.tabs.includes(tab)) this.selectTab(tab.dataset.tab);
        }, options);
        this.addEventListener('keydown', (event) => {
          const tab = event.target.closest('[data-tab]');
          const index = this.tabs.indexOf(tab);
          if (index < 0) return;
          let nextIndex;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight') nextIndex = index + (rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') nextIndex = index + (rtl ? 1 : -1);
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.tabs.length - 1;
          else return;
          event.preventDefault();
          const nextTab = this.tabs[(nextIndex + this.tabs.length) % this.tabs.length];
          nextTab.focus();
          this.selectTab(nextTab.dataset.tab);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          this.selectTab(event.detail.blockId);
        }, options);
        this.observer?.disconnect();
        this.observer = new ResizeObserver(() => this.refreshCarousel());
        this.observer.observe(this);
        this.refreshCarousel();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.refreshFrame);
      }

      selectTab(blockId) {
        if (!this.tabs.some((tab) => tab.dataset.tab === blockId)) return;
        this.tabs.forEach((tab) => {
          const selected = tab.dataset.tab === blockId;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.tabPanel !== blockId;
        });
        this.refreshCarousel();
      }

      refreshCarousel() {
        cancelAnimationFrame(this.refreshFrame);
        this.refreshFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const panel = this.panels.find((item) => !item.hidden);
          const carousel = panel?.querySelector('carousel-slider');
          if (!carousel?.slider || carousel.slides.length < 2) return;
          carousel.handleBreakpointChange();
          if (carousel.progress) carousel.updateProgress();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        if (!isLargeScreen && this.toggle.matches('.js-toggle')) {
          const menu = this.closest('main-menu');
          const index = menu?.mobileDisclosures?.indexOf(this.disclosure);
          this.disclosure.open = menu?.mobileHistoryPath?.includes(index) || false;
        } else if (!isLargeScreen) {
          this.disclosure.open = this.closest('main-menu')?.getMobileAccordionState?.(this.disclosure) ?? false;
        } else {
          this.disclosure.open = isLargeScreen;
        }
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        // Full-page mobile panels are controlled by MainMenu; only accordions animate their height here.
        if (!isLargeScreen && this.toggle.matches('.js-toggle')) return;
        if (!(this.matches('.js-mega-nav') && isLargeScreen)) {
          super.handleToggle(e);
          if (!isLargeScreen) this.closest('main-menu')?.saveMobileAccordionState?.();
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-route"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('travel-route-map')) {
    class TravelRouteMap extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.initialize();
      }

      disconnectedCallback() {
        this.teardown();
        this.initialized = false;
      }

      initialize() {
        this.route = [
          'China',
          'Kazakhstan',
          'Russia',
          'Georgia',
          'Turkey',
          'Paris',
          'Spain',
          'Portugal',
          'Morocco',
          'Dakar',
          'Africa',
        ];

        this.map = this.querySelector('.travel-route-section__map');
        this.marker = this.querySelector('.current-marker');
        this.motionSegments = Array.from(this.querySelectorAll('.motion-segment'));
        this.maskSegments = Array.from(this.querySelectorAll('.mask-segment'));
        this.cityElements = new Map(
          Array.from(this.querySelectorAll('.city-state')).map((element) => [element.dataset.city, element])
        );
        this.pinMasks = new Map(
          Array.from(this.querySelectorAll('[data-pin-mask]')).map((element) => [element.dataset.pinMask, element])
        );

        if (
          !this.map ||
          !this.marker ||
          this.motionSegments.length === 0 ||
          this.motionSegments.length !== this.maskSegments.length
        ) {
          return;
        }

        const routePair = (this.dataset.routeSegment || '').split('|');
        const progress = this.validateProgress({
          from: routePair[0],
          to: routePair[1],
          progress: this.clamp(Number(this.dataset.progress) / 100),
        });

        this.options = {
          duration: Math.max(0, Number(this.dataset.duration) || 0),
          triggerThreshold: this.clamp(Number(this.dataset.triggerThreshold) / 100),
          progress: progress,
        };

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.started = false;
        this.resizeTimer = null;
        this.animationFrame = null;
        this.handleResize = this.onResize.bind(this);

        this.segmentData = this.motionSegments.map((path, index) => {
          const length = path.getTotalLength();
          const maskPath = this.maskSegments[index];
          maskPath.style.strokeDasharray = length + ' ' + length;
          maskPath.style.strokeDashoffset = String(length);
          return { path: path, maskPath: maskPath, length: length, start: 0, end: 0 };
        });

        let cumulative = 0;
        this.segmentData.forEach((segment) => {
          segment.start = cumulative;
          cumulative += segment.length;
          segment.end = cumulative;
        });

        const targetSegmentIndex = this.route.indexOf(progress.from);
        this.targetDistance =
          this.segmentData[targetSegmentIndex].start + this.segmentData[targetSegmentIndex].length * progress.progress;

        this.resetCityStates();
        this.marker.classList.remove('is-visible');
        this.renderDistance(0);
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.installObserver();
      }

      teardown() {
        if (this.observer) this.observer.disconnect();
        if (this.handleResize) window.removeEventListener('resize', this.handleResize);
        if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
        if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
        this.observer = null;
        this.resizeTimer = null;
        this.animationFrame = null;
      }

      clamp(value) {
        if (!Number.isFinite(value)) return 0;
        return Math.min(1, Math.max(0, value));
      }

      validateProgress(input) {
        const fromIndex = this.route.indexOf(input.from);
        const toIndex = this.route.indexOf(input.to);
        if (fromIndex < 0 || toIndex !== fromIndex + 1) {
          return { from: 'China', to: 'Kazakhstan', progress: 0 };
        }
        return input;
      }

      setCityActive(city) {
        const cityElement = this.cityElements.get(city);
        const pinMask = this.pinMasks.get(city);
        if (cityElement) cityElement.classList.add('is-active');
        if (pinMask) pinMask.setAttribute('opacity', '1');
      }

      resetCityStates() {
        this.cityElements.forEach((element) => element.classList.remove('is-active'));
        this.pinMasks.forEach((element) => element.setAttribute('opacity', '0'));
      }

      getPointAtTravelDistance(distance) {
        const safeDistance = Math.max(0, Math.min(this.targetDistance, distance));
        let segmentIndex = this.segmentData.findIndex((segment) => safeDistance <= segment.end + 0.001);
        if (segmentIndex < 0) segmentIndex = this.segmentData.length - 1;
        const segment = this.segmentData[segmentIndex];
        const localDistance = Math.max(0, Math.min(segment.length, safeDistance - segment.start));
        const point = segment.path.getPointAtLength(localDistance);
        return { x: point.x, y: point.y };
      }

      renderDistance(distance) {
        const safeDistance = Math.max(0, Math.min(this.targetDistance, distance));

        this.segmentData.forEach((segment) => {
          const localDistance = Math.max(0, Math.min(segment.length, safeDistance - segment.start));
          segment.maskPath.style.strokeDashoffset = String(segment.length - localDistance);
        });

        this.setCityActive('China');
        this.segmentData.forEach((segment, index) => {
          if (safeDistance >= segment.end - 0.05) {
            this.setCityActive(this.route[index + 1]);
          }
        });

        const point = this.getPointAtTravelDistance(safeDistance);
        this.marker.setAttribute('transform', 'translate(' + point.x + ' ' + point.y + ')');
      }

      startAnimation() {
        if (this.started) return;
        this.started = true;
        if (this.observer) this.observer.disconnect();
        if (this.handleResize) window.removeEventListener('resize', this.handleResize);

        this.resetCityStates();
        this.marker.classList.add('is-visible');
        this.renderDistance(0);

        if (this.reduceMotion || this.targetDistance <= 0 || this.options.duration <= 0) {
          this.renderDistance(this.targetDistance);
          return;
        }

        const startTime = performance.now();
        const duration = Math.max(1, this.options.duration);

        const frame = (now) => {
          const progress = Math.min(1, (now - startTime) / duration);
          this.renderDistance(this.targetDistance * progress);
          if (progress < 1) {
            this.animationFrame = window.requestAnimationFrame(frame);
          } else {
            this.animationFrame = null;
          }
        };

        this.animationFrame = window.requestAnimationFrame(frame);
      }

      getSafeThreshold() {
        const rect = this.map.getBoundingClientRect();
        const maximumVisibleRatio = Math.min(1, window.innerHeight / Math.max(1, rect.height));
        return Math.min(this.options.triggerThreshold, Math.max(0.05, maximumVisibleRatio * 0.95));
      }

      installObserver() {
        if (this.started) return;
        if (this.observer) this.observer.disconnect();

        if (!('IntersectionObserver' in window)) {
          this.startAnimation();
          return;
        }

        const threshold = this.getSafeThreshold();
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting && entry.intersectionRatio + 0.001 >= threshold) {
                this.startAnimation();
                break;
              }
            }
          },
          { threshold: [threshold] }
        );
        this.observer.observe(this.map);
      }

      onResize() {
        if (this.resizeTimer) window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.installObserver(), 120);
      }
    }

    customElements.define('travel-route-map', TravelRouteMap);
  }

  } catch(e) { console.error(e); }
})();
})();
